<template>
  <div class="error-notification">
    <span
      class="error-notification__text"
      @click="onAction"
      v-html="$t(contentText)"
    />
    <button @click="toggleComponent()">
      <i-svg icon="icon_close" fill="#FFA4A4" />
    </button>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue';

const props = defineProps({
  content: {
    type: Object as PropType<{ link: string, key: string }> || String,
    required: true,
  },
  autoClose: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['action']);

let closeTimeout: ReturnType<typeof setTimeout>;

const { toggleComponent } = usePopups();

function onAction() {
  toggleComponent();
  emit('action');
}

function handleAutoClose(delay = 10000) {
  closeTimeout = setTimeout(toggleComponent, delay);
}

const contentKey = computed((): string => {
  if (typeof props.content === 'object') {
    return props.content?.key as string;
  }

  return '';
});

const contentText = computed((): string => {
  if (typeof props.content !== 'object')
  { return props.content as string; }

  return '';
});

onMounted(() => {
  if (props.autoClose)
  { handleAutoClose(); }
});

onBeforeUnmount(() => {
  clearTimeout(closeTimeout);
});
</script>

<style lang="scss" scoped>
.error-notification {
  position: sticky;
  top: 32px;
  display: flex;
  gap: 16px;
  align-items: center;
  max-width: 311px;
  width: 100%;
  margin: 0 auto;
  z-index: 9999;
  background: $error-bg;
  border: 2px solid $red;
  border-radius: 9px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  padding: 16px;

  &__text {
    color: $red;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
    flex-grow: 1;

    & button {
      background: transparent;
      border: none;
      padding: 0;
      display: inline;
      text-align: left;

      color: $blue;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%; /* 21px */
      text-decoration-line: underline;
    }
  }

  & button {
    background: transparent;
    border: none;
    padding: 0;
    display: flex;
  }

  & svg {
    flex-shrink: 0;
  }
}
</style>

<style lang="scss">
.error-notification__text {
  .link {
    color: $blue;
    text-decoration: underline;
  }
}
</style>
